export default "__VITE_ASSET__D5Oc07Ln__"